import { client, publicClient, x1Client } from "./client"
import * as queries from "./queries"

export const getSsoPayload = () =>
  publicClient.query({ query: queries.getSsoPayload })

export const logout = () => publicClient.mutate({ mutation: queries.logout })

export const getCurrentUser = () =>
  client.query({ query: queries.getCurrentUser() })

export const getLanguage = () => client.query({ query: queries.getLanguage() })

export const getTotalUnreadMessages = () =>
  x1Client.query({ query: queries.getTotalUnreadMessages })
